import React, { lazy, Suspense } from 'react';
import { useTranslation } from 'react-i18next';
import { Redirect, Route, Switch, useRouteMatch } from 'react-router-dom';
import HeaderTemplate from 'web-library/stories/template/HeaderTemplate/HeaderTemplate';
import Stepper from 'web-library/stories/molecule/Stepper/Stepper';
import { useManageRoute } from '../../admin/logic/useActivateAccount';
import RouteKey from '../../../routes/key';

const AccountActivationDetail = lazy(
  () => import('../../admin/components/AccountActivationDetail')
);
const SetPassword = lazy(() => import('../../admin/components/SetPassword'));

const { error: errorRoute } = RouteKey.child;

const ActivateAccountFormRoute = () => {
  const { t } = useTranslation();

  const routeSteps = [
    {
      label: t('admin->>ActivationAccountFormRoute.EnterDetails'),
    },
    {
      label: t('admin->>ActivationAccountFormRoute.SetPassword'),
    },
  ];

  const { path, url } = useRouteMatch();
  const { step, localRouteKey, toStep1, toStep2 } = useManageRoute(url);

  return (
    <>
      <HeaderTemplate>
        <Stepper activeStep={step} steps={routeSteps} />
      </HeaderTemplate>
      <Suspense fallback={null}>
        <Switch>
          <Route exact path={`${path}`}>
            <Redirect to={`${path}/${localRouteKey.detail}`} />
          </Route>

          <Route path={`${path}/${localRouteKey.detail}`}>
            <AccountActivationDetail next={toStep2} />
          </Route>

          <Route path={`${path}/${localRouteKey.setPassword}`}>
            <SetPassword back={toStep1} />
          </Route>

          <Route path="*" exact>
            <Redirect to={`/${errorRoute}`} />
          </Route>
        </Switch>
      </Suspense>
    </>
  );
};

export default ActivateAccountFormRoute;
